import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LoginPage from "./LoginPage";
import { loadAccounts } from "Actions/accountActions";
import { hidePayModal, hidePayVeil } from "Actions/uiActions";
import { resetStore } from "Actions/applicationActions";


function mapStateToProps(state) {
	return {
		accountsInfo: state.accounts
	};
}

function mapDispatchToProps(dispatch) {
	return {
		resetStore: bindActionCreators(resetStore, dispatch),
		loadAccounts: bindActionCreators(loadAccounts, dispatch),
		hidePayVeil: bindActionCreators(hidePayVeil, dispatch),
		hidePayModal: bindActionCreators(hidePayModal, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/atomic/pages/LoginPage/index.js